import { StepIconClasskey } from "@mui/material";
import { OverridesStyleRules } from "@mui/material/styles/overrides";

export const stepIconStyles: Partial<OverridesStyleRules<StepIconClasskey>> = {
    root: {},
};
